import { useTranslation } from 'react-i18next';

import { AddClientUserButton, ClientUsersListPanel } from '@/views';
import { Auth, Icon, Page } from '@/components';
import { useUserContextSelector } from '@/redux';

function _ClientUsersListPage() {
  const { t } = useTranslation();

  const [isAdmin, adminClientId] = useUserContextSelector((x) => [
    x.isAdmin,
    x.adminClientId,
  ]);

  return (
    <Page htmlTitle={t('users.title')}>
      <Page.Paths>
        <Page.Path>{t('users.title')}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={t('users.title')}
          icon={<Icon type="users" />}
          color="#44A2B4"
          actions={
            isAdmin && <AddClientUserButton organizationId={adminClientId} />
          }
        >
          {isAdmin && (
            <ClientUsersListPanel
              organizationId={adminClientId}
              showClientName
            />
          )}
        </Page.Card>
      </Page.Body>
    </Page>
  );
}

export const ClientUsersListPage = Auth.Banner(['BFP_ADMIN', 'CLIENT_ADMIN'])(
  _ClientUsersListPage,
);
